import API from "../configs/axiosInstance";

const getAccountScanPermissions = (id) => {
  return API({
    url: `/account-service/v1/account-scan-permissions`,
    method: 'GET',
  });
};       

const scanPermissionService = {
  getAccountScanPermissions,
};

export default scanPermissionService;